/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 13:19:34
 * @LastEditors: duyuanyuan
 * @LastEditTime: 2023-09-28 14:37:19
 * @FilePath: \panda-index-sicermem-frontend\src\locales\zh-CN\aboutUs.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
		"About.index.424704-0": "AppKit Landing 是完美着陆页模板",
		"About.index.424704-1": "为你的项目",
		"About.index.424704-2": "它可以帮助您构建美观有效的着陆页，以推广您的产品或副业项目!",
		"About.index.424704-3": "Bootstrap爱好者?",
		"About.index.424704-4": "AppKit Landing 基于 Bootstrap 5 和 SASS 构建，因此可以快速轻松地进行自定义!",
		"About.index.424704-5": "准备好打造卓越的产品了吗?",
		"About.index.424704-6": "立即获取 AppKit Landing，它将帮助您有效地推广您的产品!",
		"About.index.424704-7": "为什么要使用 AppKit Landing？",
		"About.index.424704-8": "Appkit Landing 采用现代前端技术，并包含大量实用组件和小部件，可加快您的开发速度。",
		"About.index.424704-9": "软件研发服务",
		"About.index.424704-10": "提供可用的软件研发服务，开发平台覆盖运动应用、网站系统、小程序等",
		"About.index.424704-11": "数字化战略咨询",
		"About.index.424704-12": "人工智能技术",
		"About.index.424704-13": "在数字化时代构筑可持续竞争优势，提升企业核心竞争力",
		"About.index.424704-14": "深耕人工智能技术研发与落地应用，为企业提供 AI 场景化定制开发、智能算法优化、数智化能力升级等专业服务，助力企业降本增效，实现智能化转型"
};
